import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useFilterChangeCallback } from 'shared/hooks';
import { selectIsByCommercialOwner } from 'shared/selectors/jsonQuery/selectIsByCommercialOwner';

import { FILTER_KEY } from './constants';

export const IsByCommercialOwnerContainer: FC = () => {
  const value = useSelector(selectIsByCommercialOwner);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setIsByCommercialOwner', arguments: [newValue || null] });
    },
    [onChange],
  );

  return <Checkbox checked={!!value} label={'От собственника'} onChange={handleChange} />;
};
